export default [
    {
        path: '/website-filter-pages',
        props: true,
        component: () => import('@/views/WebsiteFilterPage'),
    },
];
